import { Injectable } from "@angular/core";
import "../../../core/utils/localStorage.extensions";
import { Router } from "@angular/router";
import { VexRoute } from "@vex/interfaces/vex-route.interface";
import { FlowAccountService } from "src/wf/app/services";
import jwt_decode from "jwt-decode";
import { WorkflowRoutes } from "../app-routing.module";

@Injectable({
    providedIn: "root",
})
export class WorkflowRoutingService {

    constructor(
        private router: Router,
        private flowAccountService: FlowAccountService,
    ) {}



    async configureWorkflowRoutes() {
        if (this.flowAccountService.isAuthenticated()) {
          const tenant = localStorage.getItem('workflowTenantName');
          const token = localStorage.getItem('access_token');
          let identity = null;
          try {
            identity = token ? jwt_decode(token) : null;
          } catch (error) {
            console.error('Failed to decode token:', error);
          }
    
          let routes = this.router.config.map(route => {
            return {
              ...route,
              data: {
                ...route.data,
                tenant: tenant,
                identity: identity
              }
            };
          });
    
          this.router.resetConfig(routes);
        }
      }
    }